/**
 * GYIK section -- accordion + tab filter + load more.
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.gyik');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var list      = section.querySelector('.gyik__list');
    var items     = list ? Array.prototype.slice.call(list.querySelectorAll('.gyik__item')) : [];
    var tabs      = Array.prototype.slice.call(section.querySelectorAll('.gyik__tab'));
    var moreWrap  = section.querySelector('.gyik__more');
    var moreBtn   = section.querySelector('.gyik__more-btn');
    var baseLimit = parseInt(section.getAttribute('data-limit'), 10) || 5;
    var hasTabs   = tabs.length > 0;
    var activeCat = hasTabs ? tabs[0].getAttribute('data-cat') : null;

    /* ---- Accordion toggle ---- */
    items.forEach(function (item) {
      var btn   = item.querySelector('.gyik__question');
      var panel = item.querySelector('.gyik__answer');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';

        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          panel.offsetHeight; // reflow
          panel.style.height = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
          var onEnd = function () {
            panel.removeEventListener('transitionend', onEnd);
            if (btn.getAttribute('aria-expanded') === 'true') {
              panel.style.height = 'auto';
            }
          };
          panel.addEventListener('transitionend', onEnd);
        }
      });
    });

    function closeItem(item) {
      var btn   = item.querySelector('.gyik__question');
      var panel = item.querySelector('.gyik__answer');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) { panel.style.height = '0'; }
    }

    function applyVisibility() {
      var catItems = [];

      items.forEach(function (item) {
        if (hasTabs && activeCat !== '*' && item.getAttribute('data-cat') !== activeCat) {
          item.style.display = 'none';
          return;
        }
        catItems.push(item);
      });

      catItems.forEach(function (item, idx) {
        item.style.display = idx < baseLimit ? '' : 'none';
      });

      if (moreWrap) {
        moreWrap.style.display = catItems.length > baseLimit ? '' : 'none';
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = items.filter(function (item) {
          if (hasTabs && activeCat !== '*' && item.getAttribute('data-cat') !== activeCat) return false;
          return item.style.display === 'none';
        });

        // A gomb felirata "Összes kérdés", ezért egy kattintásra MINDET
        // megnyitjuk, nem kötegelve (ügyfél-kérés, 2026-09-03).
        hidden.forEach(function (item) {
          item.style.display = '';
        });

        if (moreWrap) {
          moreWrap.style.display = 'none';
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        activeCat = tab.getAttribute('data-cat');

        items.forEach(function (item) { closeItem(item); });
        applyVisibility();
      });
    });

    applyVisibility();
  });
})();
